export default "__VITE_ASSET__DXp2OGk0__"